/* eslint-disable react/jsx-no-bind */
//@flow
import * as React from 'react';
import { MultiAPIFetcher } from 'common/components/core/api_fetcher';
import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';
import { connect } from 'react-redux';
import { withRouter } from 'common/components/core/router';
import { compose } from 'recompose';
import { FetchStatusEnum } from 'common/enums/FetchEnum';
import Loader from 'common/components/core/loader/Loader';
import { APIErrorScreen } from 'common/components/core/errors/APIErrorScreen';
import { RetrySnackbar } from 'common/components/core/snackbar';
import { fetchTeamsByClient } from 'common/redux/actions/team';
import ClientActions from 'common/redux/actions/client';
import { AuthenticationActions } from 'common/modules/auth';
import ClientSettingsActions from 'common/redux/actions/clientSettings';
import ClientConfigActions from 'common/redux/actions/clientConfig';
import { IntlActions } from 'common/redux/actions/intl';
import { translate } from 'react-i18next';

class ClientDataFetcher extends React.Component {
    goHome = () => {
        const { history } = this.props;
        history.push('/');
    };
    render() {
        const {
            t,
            clientId,
            fetchClient,
            fetchClientSettings,
            fetchClientConfig,
            fetchTeamsByClient,
            fetchBusinessUnits,
            logout
        } = this.props;
        return (
            <MultiAPIFetcher
                apiActionsMap={{
                    fetchClient,
                    fetchClientSettings,
                    fetchClientConfig,
                    fetchTeamsByClient,
                    fetchBusinessUnits
                }}
                params={{ clientId }}
            >
                {({ status, onRetry, errors }) => {
                    if (status === FetchStatusEnum.Failure) {
                        const fetchClientError = errors.fetchClient;
                        return fetchClientError &&
                            fetchClientError.statusCode === 404 ? (
                            <APIErrorScreen
                                statusCode={fetchClientError.statusCode}
                                message={fetchClientError.message}
                                onActionClick={() => {
                                    logout();
                                }}
                                actionLabel={t('signOut')}
                                onSecondaryActionClick={onRetry}
                                secondaryActionLabel={t('tryAgain')}
                            />
                        ) : (
                            <RetrySnackbar
                                errorMessage={t('failedToLoadInitialData')}
                                active
                                onClick={onRetry}
                            />
                        );
                    }

                    if (status === FetchStatusEnum.Loading) {
                        return <Loader active />;
                    }

                    return this.props.children;
                }}
            </MultiAPIFetcher>
        );
    }
}
const mapStateToProps = (state, props) => {
    return {
        clientId: clientSelector(state, props)
    };
};
const EnhancedClientDataFetcher = (compose(
    withRouter,
    translate(),
    connect(mapStateToProps, {
        fetchClient: ClientActions.fetchClient,
        fetchTeamsByClient,
        fetchClientSettings: ClientSettingsActions.fetchClientSettings,
        fetchClientConfig: ClientConfigActions.fetchClientConfig,
        fetchBusinessUnits: IntlActions.fetchBusinessUnits,
        logout: AuthenticationActions.logout
    })
)(ClientDataFetcher): React.AbstractComponent<{
    children: React.Node
}>);

export default EnhancedClientDataFetcher;
export { EnhancedClientDataFetcher as ClientDataFetcher };
